import { useTranslation } from 'react-i18next';
import Swal, { SweetAlertResult } from 'sweetalert2';

export const useFireAlertDelete = () => {
	const { t } = useTranslation();

	const fireAlert = async (deleteFunction: () => Promise<void>): Promise<void> => {
		const result: SweetAlertResult = await Swal.fire({
			cancelButtonText: t('_general:CANCEL'),
			confirmButtonColor: '#ff0004',
			confirmButtonText: t('_general:DELETE'),
			icon: 'warning',
			iconColor: '#ff0004',
			showCancelButton: true,
			title: t('standingData:ARCHIVE_TITLE'),
		});
		if (!result.value) return;
		try {
			await deleteFunction();
		} catch (e) {
			console.error(e);
		}
	};

	return fireAlert;
};
